import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-11629d7e"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://img2.qiuwenxinli.com/official-website/tutor-college.png",
  class: "tutor-college-img",
  slot: "导师学院"
}, null, -1));
const _hoisted_2 = [_hoisted_1];
import IndexBanner from "@/components/index/index-banner.vue";
import MySeactionHeader from "@/components/common/my-seaction-header.vue";
import PsychologyCourse from "@/components/index/psychology-course.vue";
import BusinessSegment from "@/components/index/business-segment.vue";
import MediaCoverage from "@/components/index/media-coverage.vue";
import CooperativePartner from "@/components/index/cooperative-partner.vue";
import { receiveCourse } from "@/api/common";
// Import Swiper styles
import "swiper/css";
import "swiper/css/virtual";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import { useMeta } from "vue-meta";
import router from "@/router";
import { reactive, ref } from "vue";
import { ElMessage } from "element-plus";
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    // Import Swiper Vue.js components
    useMeta({
      title: "全民幸福社",
      htmlAttrs: {
        lang: "en",
        amp: true
      },
      meta: [{
        name: "description",
        content: "想学幸福心理课,就到全民幸福社"
      }, {
        name: "kewords",
        content: "全民幸福社,幸福心理课,专业心理学导师教学,心理学读书"
      }]
    });
    function toTutorCollegeDetails() {
      router.push("/tutorcollege");
    }
    function toCourseDetails(courseId) {
      router.push({
        path: "/coursedetails",
        query: {
          courseId: courseId
        }
      });
    }
    const ruleFormRef = ref();
    const receiveCourseForm = reactive({
      name: "",
      mobile: ""
    });
    const receiveCourseFormRules = reactive({
      name: [{
        required: true,
        message: "请输入您的姓名",
        trigger: "blur"
      }, {
        min: 2,
        max: 10,
        message: "请输入 2~10 个汉字",
        trigger: "blur"
      }],
      mobile: [{
        required: true,
        message: "请输入手机号码",
        trigger: "blur"
      }, {
        len: 11,
        message: "请输入正确的手机号码",
        trigger: "blur"
      }]
    });
    function clickReceiveCourse(formEl) {
      if (!formEl) return;
      formEl.validate(valid => {
        if (valid) {
          receiveCourse(receiveCourseForm.name, receiveCourseForm.mobile).then(() => {
            ElMessage.success("领取成功");
            receiveCourseForm.name = "";
            receiveCourseForm.mobile = "";
          });
        } else {
          return false;
        }
      });
    }
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_form = _resolveComponent("el-form");
      return _openBlock(), _createElementBlock("div", null, [_createVNode(IndexBanner), _createVNode(MySeactionHeader, {
        title: "幸福心理课"
      }), _createVNode(PsychologyCourse, {
        onToCourseDetails: toCourseDetails
      }), false ? (_openBlock(), _createBlock(_component_el_form, {
        key: 0,
        ref_key: "ruleFormRef",
        ref: ruleFormRef,
        class: "receive-course",
        model: receiveCourseForm,
        rules: receiveCourseFormRules
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          prop: "name",
          class: "receive-course-input"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: receiveCourseForm.name,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => receiveCourseForm.name = $event),
            modelModifiers: {
              trim: true
            },
            placeholder: "请输入您的姓名",
            class: "receive-course-input-name"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          prop: "mobile",
          class: "receive-course-input"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: receiveCourseForm.mobile,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => receiveCourseForm.mobile = $event),
            modelModifiers: {
              trim: true
            },
            type: "tel",
            placeholder: "请输入手机号码",
            class: "receive-course-input-phone"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createElementVNode("button", {
          type: "button",
          class: "receive-course-submit",
          onClick: _cache[2] || (_cache[2] = $event => clickReceiveCourse(ruleFormRef.value))
        }, " 免费领取体验课程 ")]),
        _: 1
      }, 8, ["model", "rules"])) : _createCommentVNode("", true), _createVNode(MySeactionHeader, {
        title: "导师学院"
      }), _createElementVNode("div", {
        class: "tutor-college",
        onClick: toTutorCollegeDetails
      }, _hoisted_2), _createVNode(MySeactionHeader, {
        title: "三大业务板块"
      }), _createVNode(BusinessSegment), _createVNode(MySeactionHeader, {
        title: "媒体报道"
      }), _createVNode(MediaCoverage), _createVNode(MySeactionHeader, {
        title: "合作伙伴"
      }), _createVNode(CooperativePartner)]);
    };
  }
});